<template>
    <div
        :class="`hasActive unitCard ${inCard ? 'inCard' : ' '}  ${isNotLinked ? '': 'linked'} ${disabled ? 'disable' : ' '} ${unit.completed ? 'completed' : ''}`"
        :id="`noti-${unit.id}`"
        @click="onClick"
    >
        <div
            v-if="isDailyCoral && unit.data.imageUrl"
            class="icon-image"
        ><img :src="unit.data.imageUrl"></div>
        <span
            v-else
            :style="(color ? `background-color: ${color}` : '') + (unit.completed ? '; opacity: 0.5' : '')"
            class="icon"
        >
            <i
                v-if="unit.completed"
                class="ion ion-ios-checkmark-empty"
                style="font-size: 42px; line-height: 4px; margin-top: -4px"
            />
            <i
                v-else
                class="ion ion-ios-arrow-forward"
                style="font-size: 24px; line-height: 34px; padding-left: 3px"
            />
        </span>
        <div :class="`inner ${(index === (pack.length - 1)) ? 'lastOne' : ''} ${inCard ? 'inCard' : ''}`">
            <!-- {{ unit.type === 'game' && isLearn ? 'Play: ' : '' }}{{ unit.type === 'question' && isLearn ? 'Discuss: ' : '' }} -->
            <div class="title">{{ unit.name }}</div>
            <div class="subtitle">{{ renderDesc(unit.description) }}</div>
            <div
                v-if="disabled"
                class="status"
            >has prerequisites</div>
            <div
                v-else-if="unit.completed"
                class="status completed"
            >COMPLETED</div>
            <div
                v-else-if="unit.type === 'question'"
                class="status comments"
            >{{ unit.comments && unit.comments.total ? unit.comments.total : unit.comments }} comment{{ unit.comments > 1 ? 's' : '' }}

                <span
                    v-if="isNew()"
                    class="time"
                    style="color: #864c7d"
                >NEW</span>
            </div>
            <div
                v-else-if="unit.data"
                class="status"
            >{{ unit.started ? 'RESUME' : 'START' }}
                <div
                    v-if="unit.started"
                    class="pgBar"
                >
                    <div
                        :style="`width: ${unit.progress < 5 ? 10 : unit.progress}%`"
                        class="pgBarInner"
                    />
                </div>
                <span
                    v-if="!unit.started"
                    class="time"
                > {{ unit.data.time }} {{ unit.data.time ? 'min' : '' }}{{ unit.data.time && unit.type !== 'game' && unit.data.time > 1 ? 's' : '' }}{{ unit.type === 'game' ? ' exercise' : '' }}</span>
                <span
                    v-if="unit.hasAudio"
                    class="audio"
                ><i class="ion-headphone" /></span>
                <!-- <span
                    v-if="unit.type === 'game'"
                    class="audio"
                ><i class="ion-ios-basketball" /></span> -->
                <span
                    v-if="unit.hasVersions"
                    class="versions"
                ><i class="ion-android-funnel" /></span>
                <span
                    v-if="unit.players === 2"
                    class="versions"
                ><i class="ion-person-stalker" /></span>

                <span
                    v-if="isNew()"
                    class="time"
                    style="color: #864c7d"
                >NEW</span>

            </div>
        </div>
    </div>
</template>

<script>
import utils from '../js/utils';

export default {
    props: ['unit', 'color', 'home', 'disabled', 'index', 'pack', 'inCard', 'isLearn', 'isNotLinked', 'isDailyCoral'],
    store: ['api', 'user', 'unitsIndex', 'myTraits', 'coursesIndex', 'courses', 'currentCourse'],
    data () {
        return {};
    },
    watch: {},
    created: function () {
        // console.log('card created', this.unit.id)
        // this.$events.off(`unit-completed-${this.unit.id}`);
        this.$events.on(`unit-completed-${this.unit.id}`, () => {
            // console.log(this.unit)
            // this should only happen at the db level anymore
            // this.unit.completed = true;
            // Vue.set(this.unit, 'completed', true);
            // Vue.set(this.unitsIndex, this.unit.id, this.unit);
        });

        // This is for set as home button
        this.$events.on(`start-unit-${this.unit.id}`, this.onclick);
    },
    beforeDestroy: function () {
        // console.log('card killed', this.unit.id)
        this.$events.off(`unit-completed-${this.unit.id}`);
        this.$events.off(`start-unit-${this.unit.id}`);
    },
    methods: {
        onClick: function () {
            if (this.disabled) return;
            if (this.home) {
                if (this.coursesIndex[this.user.currentCourseId]) {
                    this.currentCourse = this.coursesIndex[this.user.currentCourseId];
                    console.log('set currentcourse vua unitcard')
                }
            }
            if (this.currentCourse)
                this.unit.courseId = this.currentCourse.id;
            if (this.unit.type === 'question') {
                this.goToInPopup(`/comments/${this.unit.id}`);
            } else {
                this.goToInPopup(`/units/${this.unit.id}`);
            }
            if (this.unit.completed || this.unit.started) return;
            if (this.isDailyCoral) {
                this.$events.fire('trackEvent', `daily_coral`, 'daily', this.unit.id, this.unit.name, this.unit);
            }
            if (!this.unit.courseId && this.currentCourse && this.currentCourse.id) {
                this.unit.courseId = this.currentCourse.id;
            }
            this.$events.fire('user-progress', {
                itemId: this.unit.isVersionOf || this.unit.id,
                courseId: this.unit.courseId || 0,
                topicId: this.coursesIndex[this.unit.courseId] ? this.coursesIndex[this.unit.courseId].topicId : 0,
                type: 'unit',
                progress: 0,
                completed: false,
                item: this.unit
            });
            this.unit.started = true;
        },
        goToInPopup: function (url) {
            if (this.disabled && !window.localStore.getItem('adminUnlockAll')) {
                return this.disabledCoach();
            }

            if (this.unit.versions) {
                for (let i = 0; i < this.unit.versions.length; i++) {
                    const v = this.unit.versions[i];
                    if (!v.published) continue;
                    if (v.isVersionOf) {
                        let validUnit = utils.checkTraits(this.myTraits, v);
                        if (validUnit && this.unit.type === 'question') {
                            url = `/comments/${v.id}${this.home ? '?home=1' : ''}`;
                            break;
                        } else if (validUnit) {
                            url = `/units/${v.id}${this.home ? '?home=1' : ''}`;
                            break;
                        }
                    }
                }
            }
            f7.views['popup'].router.navigate(url, {
                animate: false,
                clearPreviousHistory: true,
                ignoreCache: true
            });
            if (!pgap) window.history.pushState(null, "", '/web' + url);
            setTimeout(() => {
                f7.popup.get('#popup').open();
            }, 550);
        },
        disabledCoach: function () {
            f7.toast
                .create({
                    text: `Oops... You need to finish the content earlier in your feed to access this unit!`,
                    position: 'center',
                    closeTimeout: 2000
                })
                .open();
        },
        renderDesc: function (desc) {
            return desc.length < 80 ? desc : desc.substring(0, 80) + '...';
        },
        unitType: function (type) {
            return {
                lesson: 'Learn',
                story: 'Listen',
                tracker: 'Check in',
                game: 'Play',
                quiz: 'Quiz',
                question: 'Discuss',
                message: 'Announcement'
            }[type];
        },
        isNew: function () {
            var fortnightAway = new Date(Date.now() - 12096e5);
            if ((new Date(this.unit.createdAt).getTime() - fortnightAway.getTime()) > 0) {
                return true;
            }
            return false;
        }
    }
};
</script>
<style lang="less" scoped>
@import '../css/colors.less';
.unitCard {
    &.disable {
        .icon,
        .title,
        .subtitle,
        .status,
        .inner:before {
            opacity: 0.35 !important;
        }
    }
    cursor: pointer;
    // background: @background;
    // border: 0.33px solid #eee;
    // width: 90%;
    // padding: 13px 10px 10px 20px;
    margin: 0px auto 0px;
    padding: 10px 10px 6px 10px;
    &.inCard {
        background: white;
        border-radius: 12px;
        margin: 12px 16px;
    }
    text-align: center;
    -webkit-transform: translate3d(0%, 0%, 0);
    transform: translate3d(0%, 0%, 0);
    .icon {
        float: left;
        border-radius: 50%;
        height: 38px;
        width: 38px;
        line-height: 38px;
        font-size: 20px;
        background-color: @coral;
        color: white;
        border: 2px solid white;
        z-index: 99;
        position: relative;
    }
    &.completed .icon {
        background-color: #ccc;
    }

    .icon-image {
        img {
            height: 67px;
            position: absolute;
            top: 13px;
            left: -16px;
            opacity: 0.85;
        }
        float: left;
        margin: -14px -20px -14px -10px;
        border-radius: 12px;
        height: 106px;
        width: 50px;
        overflow: hidden;
        position: relative;
    }
    // &.linked {
    //     .inner:not(.lastOne):not(.inCard):before {
    //         z-index: 98;
    //         content: ' ';
    //         top: 51px;
    //         position: absolute;
    //         width: 4px;
    //         height: ~'calc(100% - 36px)';
    //         left: 29px;
    //         background: @coral;
    //         transform: translate3d(-50%, 0, 0);
    //     }
    // }
    &.completed {
        .inner:not(.lastOne):not(.inCard):before {
            background: #ccc;
        }
    }
    .title {
        margin-left: 49px;
        padding-top: 6px;
        font-family: AndesLight;
        font-size: 18px;
        color: #111;
        text-align: left;
    }
    &.completed .title {
        color: #808080;
    }
    .subtitle {
        margin-left: 49px;
        padding-top: 4px;
        font-family: AndesLight;
        font-size: 15px;
        text-align: left;
        line-height: 15px;
        color: @darkGray;
    }
    .status {
        margin-left: 49px;
        text-transform: uppercase;
        padding-top: 6px;
        font-family: AndesMedium;
        font-size: 15px;
        text-align: left;
        color: @coral;
        &.comments {
            color: #ccc;
        }
        .pgBar {
            display: inline-block;
            height: 5px;
            background: #ccc;
            border-radius: 4px;
            line-height: 9px;
            margin-left: 8px;
            width: 50px;
            margin-bottom: 2px;
            .pgBarInner {
                display: block;
                height: 5px;
                border-radius: 4px;
                background: @coral;
            }
        }
        .audio,
        .versions {
            padding-left: 6px;
            color: #808080;
        }
        .time {
            padding-left: 6px;
            color: #ccc;
        }
    }
    .completed {
        color: #809c92;
    }
    &.active-state {
        background: transparent; // didnt look good
    }
}
.theme-dark {
    .unitCard {
        &.inCard {
            background: @black;
        }
        &.active-state {
            background: transparent;
        }
        &.completed .icon {
            background-color: @black;
        }
        .icon {
            border: 2px solid @black;
        }
        .title {
            color: white;
        }
        .subtitle {
            color: #ddd;
        }
    }
}
</style>
